import { motion, useReducedMotion } from "framer-motion";
import { Footer } from "@/components/site/Footer";
import { Navbar } from "@/components/site/Navbar";

export const StandalonePageShell = ({ eyebrow, title, description, content, children }) => {
  const reduceMotion = useReducedMotion();
  const chrome = {
    home: content?.home,
    contact: content?.contact,
    dealers: content?.dealers,
  };

  return (
    <div data-testid="standalone-page-shell" className="min-h-screen overflow-x-clip bg-cream text-ink">
      <Navbar content={chrome} alwaysVisible />
      <main className="pt-[7.25rem]">
        <section data-testid="standalone-page-hero" className="relative overflow-hidden bg-ink px-5 py-20 text-cream sm:px-8 lg:py-28">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_86%_20%,rgba(122,69,11,.52),transparent_31%),radial-gradient(circle_at_8%_100%,rgba(246,240,230,.12),transparent_30%)]" />
          <motion.div
            initial={reduceMotion ? false : { opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
            className="relative mx-auto max-w-7xl"
          >
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-brand">{eyebrow}</span>
            <h1 className="mt-5 max-w-4xl font-heading text-4xl font-bold tracking-tight sm:text-6xl">{title}</h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-cream/70 sm:text-lg">{description}</p>
          </motion.div>
        </section>
        {children}
      </main>
      <Footer content={chrome} />
    </div>
  );
};
